import React from 'react';
import styled from 'styled-components';

const Styles = styled.div`
    &&& {
        position: absolute;
        width: 480px;

        display: flex;
        flex-direction: column;

        background: #ffffff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        border-radius: 8px;

        padding: 24px;
    }
`;

export type MenuContainerProps = {
    top: number;
    left: number;
    children?: any[];
};

export const MenuContainer = ({ top, left, children }: MenuContainerProps) => {
    return (
        <Styles style={{ top: top + 'px', left: left + 'px' }} className="create-flow-item-menu">
            {children}
        </Styles>
    );
};
